import * as yup from "yup";

export const editServerProductQuote = yup.object().shape({
  companyId: yup.number().label("Company"),
  product_id: yup.number().required().label("Product"),
  reseller_id: yup.number().required().label("Reseller"),
  bdm_id: yup.number().required().label("BDM"),
  estimated_price: yup.number().min(1).default("").label("Estimated Price"),
  comments: yup.string().required().label("Comments"),
  status: yup.string().required().label("Status")
});